import FlightNextDay from '@/views/FlightNextDay/index.vue'

const FlightNextDayRouter = {
  path: '/flight-next-day',
  name: 'FlightNextDay',
  component: FlightNextDay,
  props: (route) => ({
    secret: route.query.secret
  })
}

export default FlightNextDayRouter
